// anim
import * as thankYouAnim from '../assets/anim/newMsg.json'
import * as communityAnim from '../assets/anim/communityLottie.json'


export {
  thankYouAnim,
  communityAnim,
}
